import { render, staticRenderFns } from "./FilterCampaign.vue?vue&type=template&id=2c8379e6&scoped=true&"
import script from "./FilterCampaign.vue?vue&type=script&lang=js&"
export * from "./FilterCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8379e6",
  null
  
)

export default component.exports